export default {"src":"/_next/static/media/logo.4421c92a.svg","height":143,"width":114};